import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import './button.sass'
import { useButtonStylesFromProps, constructClassNamesAndChildProps } from './buttonHelpers'
import { ApplicationContext } from '../../contexts/ApplicationContext'
import { track } from '../../utils/tracking'

export const Button = ({
  children,
  trackAs,
  onClick,
  type,
  disabled,
  target,
  rel,
  style,
  title,
  className,
  ...props
}) => {
  const { trackingDetails } = useContext(ApplicationContext)
  const [loading, setLoading] = useState(false)

  const buttonStyle = useButtonStylesFromProps(props)
  const classes = classNames(
    constructClassNamesAndChildProps({ className, ...props}, buttonStyle),
    className
  )

  const onClickHandler = (event) => {
    props.loadingText && setLoading(true)
    trackAs && track(trackAs, {...trackingDetails, ...props.trackingDetails})
    onClick && onClick(event)
  }

  if (props.href) {
    return (
      <a
        style={style}
        href={props.href}
        title={title}
        disabled={disabled || false}
        target={target || '_self'}
        rel={rel || 'nofollow'}
        className={`${classes} ${loading ? 'disabled' : ''}`}
        onClick={onClickHandler}>
        {loading ? props.loadingText : children}
      </a>
    )
  } else {
    return (
      <button style={style} disabled={disabled || false} className={classes} onClick={onClickHandler} type={type || 'button'} title={title}>
        {loading ? props.loadingText : children}
      </button>
    )
  }
}

export const DropdownButton = ({
  primaryButtonText,
  href,
  onButtonClick,
  onDropdownClick,
  dropdownMenuOpen,
  trackButtonAs,
  trackDropdownAs,
  disabled,
  loadingText,
  dropdownDataTest
}) => {
  return (
    <div className='dropdown-button'>
      <Button primary
        fullWidth disabled={disabled}
        loadingText={loadingText}
        trackAs={trackButtonAs} href={href}
        onClick={onButtonClick}>
        {primaryButtonText}
      </Button>
      <Button trackAs={trackDropdownAs} onClick={onDropdownClick} secondary>
        <span className={`dropdown-arrow ${dropdownMenuOpen ? 'dropdown-menu-open' : ''}`} data-test={dropdownDataTest} />
      </Button>
    </div>
  )
}

export const IconButton = ({
  Icon,
  trackAs,
  onClick,
  style,
  ...props
}) => {
  const { trackingDetails } = useContext(ApplicationContext)

  const buttonStyle = useButtonStylesFromProps(props)
  const className = constructClassNamesAndChildProps(props, buttonStyle)

  const onClickHandler = (event) => {
    trackAs && track(trackAs, {...trackingDetails, ...props.trackingDetails})
    onClick && onClick(event)
  }
  return (
    <button
      className={className}
      onClick={onClickHandler}
      >
        <Icon className={`button--icon_svg`}/>
      </button>
  )
}
